import { render, staticRenderFns } from "./applicant-address.vue?vue&type=template&id=59f398c2&scoped=true"
import script from "./applicant-address.vue?vue&type=script&lang=ts"
export * from "./applicant-address.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f398c2",
  null
  
)

export default component.exports